import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import {useContext, useState} from 'react'
import {PurchaserReportContext} from '../../context'
import moment from 'moment'
import {SampleCSVDownload} from '../../../../components/SampleCSVDownload'
import Import from '../../../../images/Import.png'
import {MIN_DATE_RANGE, dataToPurchaserReportsCSV} from '../../utils'

const PurchaserReportsHeader = () => {
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')
  const [isLoading, setIsLoading] = useState(false)

  const {handlePurchaserReportDateChange, purchaserReportData} = useContext(PurchaserReportContext)

  const handleDateChange = (startDate: any, endDate: any) => {
    handlePurchaserReportDateChange(startDate, endDate)
  }

  const handleDownLoadCSV = async () => {
    setIsLoading(true)
    const formattedDateTime = moment().format('D_MMM_HH_mm').toLowerCase()
    const data = dataToPurchaserReportsCSV(purchaserReportData)
    if (data?.length) {
      SampleCSVDownload(data || [], `Purchaser_By_Supplier_Report_${formattedDateTime}`)
    }
    setIsLoading(false)
  }

  return (
    <div className='d-flex flex-wrap justify-content-end mb-10 gap-5'>
      <button
        className='btn btn-outline'
        onClick={handleDownLoadCSV}
        disabled={isLoading || !purchaserReportData?.length}
      >
        <div className='d-flex align-items-center'>
          <img src={Import} alt='Import File' className='me-2 import-icon' />
          <div className='d-flex align-items-center'>
            {isLoading ? 'Downloading...' : 'Export CSV'}
            {isLoading && (
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            )}
          </div>
        </div>
      </button>
      <div className='w-250px'>
        <PredefinedDateRange
          cb={handleDateChange}
          defaultValue={dateRangeLabel || 'Last 90 Days'}
          includeCurrantDay={true}
          startDate={MIN_DATE_RANGE}
        />
      </div>
    </div>
  )
}

export default PurchaserReportsHeader
